

import React from 'react'

function Shimmer() {
  return (
    <div className='flex items-center'>
      <h1 className=''>No Internet Connection</h1>
    </div>
  )
}

export default Shimmer
